import { css } from '@emotion/core';
import { variables, mq } from '../../../cssInJs';

const numberOfTiles = [1, 2, 3, 3]
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14, 14]

const widthPercent = (index) => 100 / numberOfTiles[index] + '%'

const linkText = {
  color: variables.fontColor,
  fontSize: '0.8rem',
  // padding: '0 20px',
  '&:hover': {
    color: variables.fontColor,
  }
}

export const tileListStyle = {
  tiles: mq({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    //marginLeft: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    //marginRight: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth: ['1200px'],
    margin: 'auto'
  }),
  categoryList: mq({
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth: ['1200px'],
    margin: 'auto',
    'div.ff.form-group': {
      maxWidth: '250px'
    }
  })
}

export const tileStyle = {
  tile: mq({
    //paddingLeft: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    //paddingRight: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    flexGrow: '1',
    flexShrink: '0',
    flexBasis: ['100%', null, '25%'],
    maxWidth: ['100%', null, '25%'],
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '0.7rem',
    paddingRight: '0.7rem',
    'a': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      // overflow: 'hidden',
      '&:hover': {
        textDecoration: 'none',
        '.productTile__prdImage .productTile__bg': {
          transform: 'scale(1.05)',
        }


      }
    }
  }),
  // tileLink: {
  //   background: '#fff',
  //   height: '100%',
  //   display: 'flex',
  //   flexDirection: 'column',
  //   //padding: 5,
  //   //border: '1px solid red',
  //   '&:hover': {
  //     textDecoration: 'none'
  //     //background: '#f3f3f3'
  //   }
  // },
  prdImage: {
    //padding: '0 5px',
    //maxWidth: '190px',
    //margin: 'auto',
    //width: '100%',
    boxShadow: '3px 1px 12px rgba(0,0,0,0.5)',

    //padding:'0.3rem',
    backgroundColor: variables.lightGrayColor,
    overflow: 'hidden',
  },
  bg: {
    //height: 0,
    //paddingBottom: '100%',
    paddingTop: '56.25%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    transition: 'all 0.2s',
  },
  detailsContainer: {
    padding: '1rem 0.8rem',
    flex: '1 0 auto',
    position: 'relative',
    overflow: 'hidden',
    flexGrow: '1',
    backgroundColor: 'white',
    // marginTop: '-20px',
    // width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '3px 1px 12px rgba(0,0,0,0.5)',
  },
  shortDes: css({
    lineHeight: '1.3',
    fontSize: '0.7rem',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    color: `${variables.fontColor} !important`,
    marginBottom: '1rem',
  }),
  name: css(linkText, {
    color:'#0081a2 !important',
    fontSize: '1rem',
    textTransform: 'uppercase',
    fontWeight: 700,
    lineHeight: 1,
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
  }),
  price: css(linkText, {
    marginTop: 'auto',
    textAlign: 'center',
    fontSize: '1.2rem',
    fontWeight: 700,
    color: '#0081a2 !important',
  }),
  hr: css({
    width: '20% !important',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    borderTopColor: `black !important`,
    marginLeft: '0 !important',
    marginRight: '0 !important'
  }),
  priceContainer: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 0.8rem',
    marginTop: 'auto',
  }),
  viewProduct: css({
      borderRadius: '5px',
      backgroundColor: '#0081a2',
      color: 'white',
      fontWeight: 700,
      borderRadius: '5px',
      padding: '0.375rem 0.75rem',
      transition: 'all 0.15s',
      '&:hover': {
        color: 'white !important',
        backgroundColor: '#00456E !important',
      }
    }),
}